import Skeleton from '@mui/material/Skeleton';
import LayoutContainer from '../../../common/Layout/Layout';
import SkeletonCourseCard from '../CourseCard/SkeletonCourseCard';
import styles from './SkeletonCarousel.module.scss';

const SkeletonCarousel = ({ cards = 3 }) => {
  const cardElements = Array.from({ length: cards }, (_, index) => <SkeletonCourseCard key={index} />);

  return (
    <LayoutContainer>
      <div className={styles.carousel}>
        <div className={styles.top}>
          <Skeleton className={styles.title} />
          <Skeleton variant="rectangular" className={styles.controls} />
        </div>
        <div className={styles.slider}>{cardElements}</div>
      </div>
    </LayoutContainer>
  );
};

export default SkeletonCarousel;
